<div class="labels">
  @for (label of labels; track label) {
    <div class="item-label">
      <span>{{ label }}</span>
    </div>
  }
  <div class="vertical-units">Number of Matches</div>
</div>
<div class="bins">
  @for (line of lines; track line) {
    <div class="line" [style]="'--index:' + line">
      @if (line !== 0) {
        <span>{{ line }}</span>
      }
    </div>
  }
  @for (bin of bins; track bin) {
    <div class="bin" [attr.bin-hover]="hoverMode === 'bin' || null">
      @for (item of bin.items; track item) {
        <div
          [ngClass]="{ item: true, disabled: item.disabled }"
          [attr.item-hover]="hoverMode === 'item' || null"
          (mouseover)="itemHovered.emit({ bin, item })"
          (focus)="itemHovered.emit({ bin, item })"
          (mouseout)="itemHovered.emit(undefined)"
          (blur)="itemHovered.emit(undefined)"
          (click)="itemClicked.emit({ bin, item })"
          (keyup.enter)="itemClicked.emit({ bin, item })"
          [style]="'--count:' + item.count"
          tabindex="0"
        ></div>
      }
      <div class="label">{{ bin.date | localizedDate: 'shortFormat' }}</div>
    </div>
  }
</div>
